<template>
    <div class="body">
        <edit></edit>
    </div>
</template>
<script>
import edit from "@/components/categoryComponents/edit";
export default { 
    components: {
        edit,
    },
};
</script>
  
  
  
  
  